;(function () {
  window.initTogglers = function (scope) {
    return $(scope)
      .find("[data-toggle]")
      .each(function () {
        var target, toggle
        toggle = $(this)
        target = $("" + toggle.data("toggle"))
        return toggle.click(function () {
          var newText, oldText
          target.toggle()
          newText = toggle.data("toggle-text")
          if (newText !== void 0) {
            oldText = toggle.html()
            toggle.html(newText)
            return toggle.data("toggle-text", oldText)
          }
        })
      })
  }
}).call(this)
